import { render, staticRenderFns } from "./settings-wizard.vue?vue&type=template&id=1cbdd1d2&"
import script from "./settings-wizard.vue?vue&type=script&lang=js&"
export * from "./settings-wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports